import React, {useEffect} from 'react'
import SrpListItem from './srp_list_item';
import { SrpAds } from '../ads/srpAds';
import { leadFormPhoneNumbers } from '../util/listhub_source';

const defaults = require('../defaults');

const shuffleArray = () => {
    let array = [0, 1, 2, 3, 4];
    array.sort(() => Math.random() - 0.5);
    return array;
}

let randomArr = shuffleArray();

const SrpList = (props) => {
    const {items, openModalClick, reportingServerPath, hoverPin, totalListings, getResults, trackingEnabled,
            requestListingFrom, addlResultsCount, searchUI, showMap, affiliate, affiliateShortName, showAdTile} = props;
    const myListTopRef = React.createRef()   // Create a ref object
    const defaultConfig = defaults[affiliateShortName.split("_")[1]];
    const listHubProviderId = defaultConfig.listHubProviderId || null;
    const footer = document.getElementById("footer-wrapper");
    const footerElement = footer
                            ? document.getElementById("footer-wrapper").innerHTML
                            : null;

    const trackLHSearchResults = (listHubProviderId, items) => {
        const lhItems = items && items
            .filter(item => item._source && item._source.listhub_key)
            .map((item) => ({ lkey: item._source.listhub_key }));
        if (listHubProviderId && lhItems && lhItems.length) {
            const _lh = new window.ListHubTracker({provider: listHubProviderId, test: !trackingEnabled});
            _lh.submit('SEARCH_DISPLAY', lhItems);
        }
    }

    useEffect(() => {
        trackingEnabled && trackLHSearchResults(listHubProviderId, items)
    }, [items])

    return (
        <div className={`srp-list ${!showMap ? "full-width" : ""}`}>
            <div ref={myListTopRef} >
                {items !== null && requestListingFrom !== 0
                    && <div className="prev-container">
                        <button
                        className="prev-next hidden"
                        onClick={() => {
                            searchUI().start();
                            getResults(() => (searchUI().complete()), null, 'decrease');
                            randomArr = shuffleArray();
                        }
                        }
                        >
                        Previous 30 Results
                        </button>
                    </div>
                }
            </div>
            {items === null
                ? ""
                : items.length
                    ? items.map((item, key) => {
                        return (
                            <>
                                <SrpListItem
                                    key={key}
                                    hoverPin={hoverPin}
                                    reportingServerPath={reportingServerPath}
                                    item={item._source}
                                    itemKey={item._id}
                                    clickFunction={openModalClick}
                                    affiliate={affiliate}
                                />
                                {/* if hideAd is undefined or false in defaults.js */}
                                {/* and phone number is defined in listhub_source.js, then we'll display ad tiles */}
                                {showAdTile && leadFormPhoneNumbers[affiliate] && (key - 3) % 8 === 0 &&
                                    <SrpAds index={randomArr[key % 5]} phoneNumber={leadFormPhoneNumbers[affiliate]} position={key+1}/>
                                }
                            </>
                        )})
                    : null
            }
            {addlResultsCount >= 0
                ? <div className="next-container">
                    <button
                        className="prev-next hidden"
                        onClick={() => {
                            searchUI().start();
                            getResults(() => (searchUI().complete()), null, 'increase');
                            randomArr = shuffleArray();
                            if (myListTopRef.current){
                                myListTopRef.current.scrollIntoView();
                            }
                        }}
                    >
                        Next {addlResultsCount} Results
                    </button>
                    </div>
                : ""
            }
            {!!footerElement && !!items &&
                <div dangerouslySetInnerHTML={{__html: footerElement}} />
            }
        </div>
    )
}

export default SrpList
